import FilterMetrics from './FilterMetrics.component';

export default FilterMetrics;